import React from 'react';
import { GradeTitle } from './index.styled';

// eslint-disable-next-line no-unused-vars
const RenderData = ({ resourceType }) => {
    return <GradeTitle>Grade TK</GradeTitle>;
};

export default RenderData;
